module.exports = __webpack_public_path__ + "static/media/1_James_S@2x.9267506f.jpg";